window.copyToClipboard = function (element) {
    var tempInput = $("<input>");
    $("body").append(tempInput);
    tempInput.val($(element).val()).select();
    document.execCommand("copy");
    tempInput.remove();
};